import { render } from "./AllowAccess.vue?vue&type=template&id=5bd560ef"
import script from "./AllowAccess.vue?vue&type=script&lang=js"
export * from "./AllowAccess.vue?vue&type=script&lang=js"

import "./AllowAccess.vue?vue&type=style&index=0&id=5bd560ef&lang=css"

import exportComponent from "/Users/asatokazu/Documents/dev/project/sms/mobile_main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__